import { forwardRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MUIDialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import DialogMessage from './DialogMessage';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(MUIDialog)`
  &.MuiDialog-root .MuiDialog-container .MuiPaper-root {
    ${({ center }) => !center && 'position: absolute;'}
    ${({ center }) => !center && 'bottom: 0px;'}
    background: ${({ theme }) => theme.colors.white};
    ${({ $borderRadius }) =>
      $borderRadius ? `border-radius: ${$borderRadius};` : ''}
    @media only screen and (max-width: 540px) {
      width: 95%;
      margin: 16px auto;
    }
  }
`;

const Dialog = ({
  type,
  dialogState,
  onClose,
  heading,
  message,
  messageWidth,
  acceptLabel,
  acceptLabelVariant,
  acceptLabelTheme,
  rejectLabel,
  acceptOnClick,
  rejectOnClick,
  showButtons,
  shareContent,
  children,
  center,
  disableBackdropClick,
  className,
  borderRadius,
  maxWidth
}) => (
  <StyledDialog
    open={dialogState}
    TransitionComponent={Transition}
    onClose={onClose}
    center={center}
    disableBackdropClick={disableBackdropClick}
    disableEscapeKeyDown={disableBackdropClick}
    className={className}
    $borderRadius={borderRadius}
    maxWidth={maxWidth}
  >
    {children || (
      <DialogMessage
        type={type}
        heading={heading}
        message={message}
        messageWidth={messageWidth}
        acceptLabel={acceptLabel}
        acceptLabelVariant={acceptLabelVariant}
        acceptLabelTheme={acceptLabelTheme}
        rejectLabel={rejectLabel}
        acceptOnClick={acceptOnClick}
        rejectOnClick={rejectOnClick}
        showButtons={showButtons}
      >
        {shareContent}
      </DialogMessage>
    )}
  </StyledDialog>
);

export default Dialog;

Dialog.propTypes = {
  type: PropTypes.oneOf(['default', 'destructive', 'informative']),
  dialogState: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  message: PropTypes.string,
  messageWidth: PropTypes.string,
  acceptLabel: PropTypes.string,
  acceptLabelVariant: PropTypes.oneOf(['hollow', 'filled']),
  acceptLabelTheme: PropTypes.oneOf(['red', 'green', 'blue']),
  rejectLabel: PropTypes.string,
  acceptOnClick: PropTypes.func,
  rejectOnClick: PropTypes.func,
  showButtons: PropTypes.bool,
  shareContent: PropTypes.node,
  children: PropTypes.node,
  center: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  className: PropTypes.string,
  borderRadius: PropTypes.string,
  maxWidth: PropTypes.oneOf([PropTypes.string, PropTypes.bool])
};

Dialog.defaultProps = {
  type: 'destructive',
  showButtons: true,
  heading: '',
  children: null,
  message: null,
  messageWidth: '100%',
  acceptLabel: null,
  acceptLabelVariant: 'hollow',
  acceptLabelTheme: 'red',
  rejectLabel: null,
  shareContent: null,
  onClose: null,
  acceptOnClick: () => {},
  rejectOnClick: () => {},
  center: false,
  disableBackdropClick: false,
  className: '',
  borderRadius: '',
  maxWidth: false
};
